<template>
    <aside class="" style="min-width: 280px; background-color: var(--panel);">
    </aside>
</template>

<script>
import InputRowComp from './appearence/InputRowComp.vue';
import SectionComp from './appearence/SectionComp.vue';
import FillMenuComp from './floatingpanels/FillMenuComp.vue';

export default {
    name: 'InspectorComp',
    components: {
        InputRowComp,
        SectionComp,
        FillMenuComp
    },
    props: {
        selected: {
            type: Object,
            required: false
        }
    },
    data() {
        return {}
    },
    methods: {
        setFill(key, value){ this.selected.fill[key] = value; },
        setStroke(key, value){ this.selected.stroke[key] = value; },
        setEffects(key, value){ this.selected.effects[key] = value; },
        openFillMenu() {
            alert('this will open fill menu');
        }
    },
    watch: {
        selected: {
            handler(newVal, oldVal) {
                this.selected.context.canvas.dispatchEvent(new CustomEvent('creator:inspector:update', {detail: this.selected}));
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.icon { height: 24px; min-width: 24px; padding: 0 6px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); color: var(--text); cursor: pointer; font-size: 12px; }
.inspector { border-left: 1px solid var(--border); background: var(--panel); display: grid; grid-template-rows: auto 1fr; }
.inspector-tabs { display: flex; border-bottom: 1px solid var(--border); }
.inspector .tab { flex: 1; height: 36px; border: 0; background: transparent; color: var(--muted); cursor: pointer; }
.inspector .tab.active { color: var(--text); background: var(--panel); border-bottom: 2px solid var(--accent); }
.insp-scroll { overflow: auto; padding: 10px; }
.insp-section { padding: 10px; border: 1px solid var(--border); background: var(--panel); border-radius: 10px; margin-bottom: 10px; }
.insp-title { font-size: 11px; color: var(--muted); text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 0px; }
.grid { display: grid; gap: 8px; align-items: center; }
.g4 { grid-template-columns: 1fr 1fr 1fr 1fr; }
.g2 { grid-template-columns: 1fr 3fr; }
.row { display: flex; gap: 8px; align-items: center; }
.insp-section label { color: var(--muted); font-size: 12px; }
.insp-section input[type="number"], .insp-section input[type="text"], .insp-section select { width: 100%; height: 28px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); color: var(--text); padding: 0 8px; }
.insp-section input[type="color"] { width: 36px; height: 28px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); padding: 0; }
.hex { flex: 1; }
.fill-input {
    border: 1px solid var(--border);
    width: 28px;
    height: 28px;
    aspect-ratio: 1;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-right: 1px solid transparent;
}
.fill-type {
    border: 1px solid var(--border);
    height: 28px;
    flex-grow: 1;
    padding-inline: 6px;
}
.fill-opacity input {
    flex-grow: 1;
}
.mirror-toggle { display: inline-flex; gap: 6px; padding: 4px; border-radius: 12px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.08); align-items: center; margin: 0 auto; width: fit-content; }
.mirror-option { width: 60px; height: 32px; border-radius: 8px; border: 1px solid rgba(255, 255, 255, 0.08); background: rgba(15, 15, 15, 0.18); color: rgba(255, 255, 255, 0.7); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease, color 0.2s ease; padding: 0; backdrop-filter: blur(4px); }
.mirror-option:hover { border-color: rgba(255, 255, 255, 0.18); background: rgba(255, 255, 255, 0.08); color: var(--text); transform: translateY(-1px); }
.mirror-option--length-angle { border-color: var(--accent); background: rgba(59, 130, 246, 0.18); color: var(--text); box-shadow: 0 6px 16px rgba(59, 130, 246, 0.24); }
.mirror-icon { position: relative; width: 44px; height: 22px; display: inline-block; }
.mirror-icon::before,
.mirror-icon::after { content: ''; position: absolute; opacity: 0; pointer-events: none; }
.mirror-arm { position: absolute; height: 2px; background: currentColor; top: 11px; border-radius: 2px; opacity: 0.85; transition: opacity 0.2s ease; }
.mirror-arm--left { width: 18px; left: 6px; transform-origin: left center; transform: rotate(-28deg); }
.mirror-arm--right { width: 18px; right: 6px; transform-origin: right center; transform: rotate(28deg); }
.mirror-node { position: absolute; width: 6px; height: 6px; border-radius: 50%; background: currentColor; opacity: 0.8; transition: opacity 0.2s ease; }
.mirror-node--left { left: 4px; bottom: 3px; }
.mirror-node--center { left: 50%; top: 2px; transform: translateX(-50%); }
.mirror-node--right { right: 4px; bottom: 3px; }
.mirror-option--none .mirror-icon::before { opacity: 0.55; width: 28px; height: 18px; border: 1.5px solid currentColor; border-right: 0; border-bottom: 0; border-radius: 22px 0 0 0; left: 6px; top: 4px; transform: rotate(-10deg); }
.mirror-option--none .mirror-icon::after { opacity: 0.2; width: 14px; height: 1px; background: currentColor; left: 16px; bottom: 4px; border-radius: 1px; }
.mirror-option--none .mirror-arm--right,
.mirror-option--none .mirror-node--right { opacity: 0; }
.mirror-option--angle .mirror-icon::before { opacity: 0.22; left: 12px; right: 12px; top: 11px; height: 1.5px; background: currentColor; border-radius: 2px; }
.mirror-option--angle .mirror-icon::after { opacity: 0.2; width: 1.5px; height: 18px; left: 50%; top: 2px; transform: translateX(-50%); background: currentColor; border-radius: 1px; }
.mirror-option--angle .mirror-arm--right,
.mirror-option--angle .mirror-node--right { opacity: 0.45; }
.mirror-option--length-angle .mirror-icon::before { opacity: 0.3; width: 1.6px; height: 18px; left: 50%; top: 2px; transform: translateX(-50%); background: currentColor; border-radius: 1px; }
.mirror-option--length-angle .mirror-icon::after { opacity: 0.18; left: 10px; right: 10px; bottom: 4px; height: 1.5px; background: currentColor; border-radius: 1px; }
.mirror-option--length-angle .mirror-arm,
.mirror-option--length-angle .mirror-node { opacity: 1; }
.mirror-option--length-angle .mirror-node--center { box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3); }
</style>

